/* eslint-disable import/prefer-default-export */
import { SET_SUBSCRIPTION_SWITCHING_SYNCING_STATE } from '../constants';

const defaultState = {};

export function syncingSubscriptionsSwitching(state = defaultState, action) {
    switch (action.type) {
        case SET_SUBSCRIPTION_SWITCHING_SYNCING_STATE:
            return {
                ...state,
                [action.subscriptionId]: true,
            };

        default:
            return state;
    }
}
